// extracted by mini-css-extract-plugin
export default {"CaseSearchContainer":"AeVRgvN3","ResultPanel":"NCa90oqm"};